export const BASE_URL = 'https://classpass.com';
export const URL_APP_IOS = 'https://itunes.apple.com/us/app/classpass/id912947244?mt=8&uo=4';
export const URL_APP_ANDROID = 'https://play.google.com/store/apps/details?id=com.classpass.classpass';
export const INSTAGRAM_URL = 'https://instagram.com/';
